import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import ListingItemList from "../ListingItem/ListingItemList";
import { calculateTotalPrice } from "../../../helpers/calculateTotalPrice";
import cs from "../../../components/commonStyle.css";
import s from "./SearchResults.css";

class ListingItemsData extends Component {
  render() {
    const { results, guests, base, rates } = this.props;
    return (
      <div className={cx(cs.displayFlex, cs.flexWrap, 'listItempopUpSection')}>
        {results.map((item, listIndex) => {
          const calculatedValues = calculateTotalPrice({
            listingData: item?.listingData, listBlockedDates: item?.blockedDates, serviceFees: item?.serviceFees, base, rates
          });
          return (
            <div className={cx(s.listItem, 'listItempopUp')} key={item?.id}>
              <ListingItemList
                id={item?.id}
                basePrice={item?.listingData?.basePrice}
                currency={item?.listingData?.currency}
                title={item?.title}
                city={item?.city}
                state={item?.state}
                country={item?.country}
                personCapacity={item?.personCapacity}
                userAmenities={item?.userAmenities.concat(item?.userSafetyAmenities).concat(item?.userSpaces)}
                coverPhoto={item?.coverPhoto}
                listPhotos={item?.listPhotos}
                bookingType={item?.bookingType}
                wishListStatus={item?.wishListStatus}
                isListOwner={item?.isListOwner}
                personCount={guests}
                oneTotalPrice={item?.listingData?.oneTotalPrice}
                calculatedValues={calculatedValues}
              />
            </div>
          );
        })}
      </div>
    );
  }
}
const mapState = (state) => ({
  base: state?.currency?.base,
  rates: state?.currency?.rates
});
export default withStyles(s, cs)(connect(mapState)(ListingItemsData));